import React, { useCallback, useMemo } from 'react';

import { Text } from '../../shared/text/Text';
import styles from './AccessGroups.module.scss';
import { AccessGroup } from './store';
import { LongText } from '../../shared/longtext/LongText';

const MODAL_HEADER = 46;
const ACCESS_GROUP_NAME = 75;
const PADDING = 20;

interface AccessGroupGeneralSectionProps {
    accessGroup: AccessGroup;
    modalHeight: number;
    updateGroup: (key: keyof AccessGroup, value: string) => void;
}

export const AccessGroupGeneralSection: React.FC<AccessGroupGeneralSectionProps> = ({ accessGroup, modalHeight, updateGroup }) => {
    const { accessGroupName, description } = accessGroup;

    const handleUpdateValue = useCallback((key: keyof AccessGroup, value: string) => updateGroup(key, value), [updateGroup]);
    const descriptionHeight = useMemo(() => (modalHeight - MODAL_HEADER - ACCESS_GROUP_NAME - PADDING) / 2, [modalHeight]);

    return (
        <div className={styles.accessGroupContentWrapper}>
            <Text
                label='Access Group Name'
                testId='access-group-name'
                onChange={e => handleUpdateValue('accessGroupName', e.target.value)}
                value={accessGroupName}
                maxLength={500}
                placeholder='Name...'
            />
            <LongText
                label='Description (optional)'
                testId='access-group-description'
                onChange={value => handleUpdateValue('description', value)}
                value={description || ''}
                placeholder='Description...'
                maxLength={2000}
                width='100%'
                height={`${descriptionHeight}px`}
            />
        </div>
    );
};
